var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconClose = function SvgIconClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.387
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C4566",
    fillRule: "nonzero",
    d: "M10.867 10.002L6.698 14.04c-.288.279-.754.279-1.04 0l-.692-.672c-.288-.279-.288-.73 0-1.006L7.921 9.5 4.966 6.637c-.288-.279-.288-.73 0-1.006l.693-.672c.288-.279.754-.279 1.04 0L10.866 9c.288.272.288.724 0 1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C4566",
    fillRule: "nonzero",
    d: "M8.529 10.002l4.169 4.039c.288.279.754.279 1.039 0l.693-.672c.288-.279.288-.73 0-1.006L11.475 9.5l2.955-2.863c.288-.279.288-.73 0-1.006l-.693-.672c-.288-.279-.754-.279-1.04 0L8.53 9c-.289.272-.289.724 0 1.003z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-close.9a5cad5c.svg";
export { ForwardRef as ReactComponent };